import { Link } from 'react-router-dom'
import { isAndroidApp, PUBLIC_ORIGIN } from '../platform'

// The privacy policy and terms, which Play reviews at their public URL. A
// bundled copy drifts from that URL with every APK that is not reinstalled, and
// disclosures that do not match the listing is this app's likeliest rejection
// cause — so inside the shell these open the live page in the browser instead.
// `server.allowNavigation` is empty, so Capacitor hands the URL to the system
// browser rather than loading it in the WebView.
export default function PolicyLink({ to, className, children }) {
  if (isAndroidApp) {
    return (
      <a href={`${PUBLIC_ORIGIN}${to}`} target="_blank" rel="noreferrer" className={className}>
        {children}
      </a>
    )
  }

  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  )
}
